import React from "react";
import "./ResortGallery.css";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function ResortGallery() {
  return (
    <section className="resortGallery">
      <div className="container">
        <h2 className="galleryTitle">OUR GALLERY</h2>
        <p className="gallerySub">Glance at our great resort</p>

         <div className="row">
            <div className="col-12">
              <video className="resort_vdo" controls muted playsInline>
                <source
                  src="/assets/images/gallery/jaltaaraa_vdo.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

        <div className="galleryGrid">
          <img src="/assets/images/gallery/img_1.webp" alt="" />
          <img src="/assets/images/gallery/img_2.webp" alt="" />
          <img src="/assets/images/gallery/img_3.webp" alt="" />
          <img src="/assets/images/gallery/img_4.webp" alt="" />
        </div>
        <Link to={"/gallery"}>
        <Button className="about-btn mt-3">VIEW MORE</Button>
        </Link>
      </div>
    </section>
  );
}

export default ResortGallery;
